module.exports = __webpack_public_path__ + "img/grey.ef1e3716.png";